(function(){
  function init(root){
    if(!root || root.dataset.ogcPromotionsReady) return;
    root.dataset.ogcPromotionsReady='true';

    var els=root.querySelectorAll('[data-reveal]');

    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){
        el.classList.add('is-visible');
      });
    }else{
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },{
        threshold:.1,
        rootMargin:'0px 0px -40px 0px'
      });

      els.forEach(function(el){
        io.observe(el);
      });
    }

    if(window.lucide && typeof window.lucide.createIcons === 'function'){
      window.lucide.createIcons({
        attrs:{'aria-hidden':'true'}
      });
    }

    root.querySelectorAll('[data-copy-coupon]').forEach(function(button){
      if(button.dataset.copyReady) return;

      button.dataset.copyReady='true';

      button.addEventListener('click',function(){
        var card=button.closest('[data-coupon-card]');
        var code=card && card.querySelector('[data-coupon-code]');

        if(!code) return;

        var value=code.textContent.trim();
        var copiedLabel=button.dataset.copiedLabel || 'Copied!';
        var copyLabel=button.dataset.copyLabel || 'Copy code';

        function showCopied(){
          button.textContent=copiedLabel;

          window.setTimeout(function(){
            button.textContent=copyLabel;
          },1800);
        }

        if(navigator.clipboard && window.isSecureContext){
          navigator.clipboard.writeText(value)
            .then(showCopied)
            .catch(function(){});
        }else{
          var input=document.createElement('textarea');
          input.value=value;
          input.setAttribute('readonly','');
          input.style.position='fixed';
          input.style.opacity='0';

          document.body.appendChild(input);
          input.select();

          try{
            document.execCommand('copy');
            showCopied();
          }catch(e){}

          document.body.removeChild(input);
        }
      });
    });
  }

  function cleanNewsletterUrl(){
    if(!window.history || !window.history.replaceState) return;

    var url=new URL(window.location.href);

    if(
      url.searchParams.has('customer_posted') ||
      url.hash === '#contact_form'
    ){
      url.searchParams.delete('customer_posted');
      url.hash='';

      var cleanUrl=
        url.pathname +
        (url.searchParams.toString()
          ? '?' + url.searchParams.toString()
          : '');

      window.history.replaceState(
        {},
        document.title,
        cleanUrl
      );
    }
  }

  function initAll(){
    document
      .querySelectorAll('[data-ogc-promotions]')
      .forEach(init);

    cleanNewsletterUrl();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',initAll);
  }else{
    initAll();
  }

  document.addEventListener('shopify:section:load',function(e){
    init(e.target.querySelector('[data-ogc-promotions]'));
  });
})();